module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABkAAAAZABIffrfgAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAD7SURBVHic7ZpRCoJAGAbH6iSBXqWObFdJ8CayPShBb/qwO0LfPK/844iLol0phUaMwGPn2hfwrOjy5dJiyJlJAFvAJgFsAZsEsAVsEsAWsEkAW8AmAWwBmwSwBWwSwBawSQBbwCYBbAGbBLAFbBKg0Zwr0B9Y32/HVKcrpYwN5vTA/eAxMzBVcPmhKw2/jZ2R7AG2gE0C2AI2CWAL2CSALWDz9wFurD8k1ebUj8K1Z8D6YvNmf4QZGIClmtFGq1tg4djVnGhw8pA9IAESwBawSQBbwCYBbAGbBLAFbBLAFrBJAFvAJgFsAZsEsAVsEsAWsEkAW8AmAWwBmw9FQhvj/rK6AwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/add-white.png
// module id = 1TSq
// module chunks = 1